export const URL = {
  TRACKING: '/api/tracking',
  GENERATE_OTP: '/api/generateOTP',
  BOD_GENERATE_OTP: '/api/bod-generateOTP',
  BOD_GENERATE_TOKEN: '/api/bod-generate-user-token',
  BOD_VERIFY_OTP: '/api/bod-verifyOTP',
  BOD_IDENTIFY_CUSTOMER: '/api/bod-identify-customer',
  BOD_CUSTOMER_INFOR: '/api/bod-customer-infor',
  BOD_VERIFY_NEW_USER_PROFILE: '/api/bod-verify-new-user-profile',
  VERIFY_OTP: 'financing/v2/verifications',
  GET_CASH_OFFER: '/api/getCashOffer',
  CREATE_APPLICATION: '/api/createApplication',
  SA_LOGIN: '/api/sa-register/login',
  SA_REGISTER_DEVICE: '/api/sa-register/register',
  SA_GET_INFO: '/api/sa-register/sa',
  SA_UNREGISTER_DEVICE: '/api/sa-register/unregister',
  SETTINGS: '/api/settings',
  TRACKING_SERVICE: 'api/tracking-service',
  CHECK_USER: 'api/checkUser',
  VERIFY_G_CAPTCHA: 'api/verify-g-captcha',
  BOD_GET_OFFERS: 'api/bod-get-offers',
  RECAL_OFFER: '/api/bod-recal-offers',
  GET_RECAL_OFFER: '/api/bod-get-recal-offers',
  GET_CUSTOMER_OFFER: '/api/customer-offer',
  BOD_ADDITION_DOCUMENT: 'api/bod-addition-document',
  BOD_CREATE_APPLICATION: '/api/bod-create-application',
  BOD_GET_NEW_CUSTOMER_INFO: '/api/bod-new-customer-info',
  GET_CONTRACT_DATE: '/api/contract',
  OVER_PAYMENT: '/overpayment-service/v1/info',
};
